import config from "../../../helper/config";
import APIHandler from "../../../handlers/APIHandler";

export const currencyTypeService = {
    getAll,
    getAllCurrencyTypes,
    addCurrencyType,
    updateCurrencyType,
    deleteCurrencyType,
};

async function getAll(limit, offset, search_term, sort_column, sort_direction) {
    const configOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };
    
    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/currency-types/getAllCurrencyTypes/?limit=${limit}&offset=${offset}&search_term=${search_term}&sort_column=${sort_column}&sort_direction=${sort_direction}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function getAllCurrencyTypes() {
    const configOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/currency-types/getAll/`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function addCurrencyType(newCurrencyType) {
    const configOptions = {
        method: "POST",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(newCurrencyType),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/currency-types/add/`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function updateCurrencyType(currencyTypeItem, currencyTypeId) {
    const configOptions = {
        method: "PUT",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(currencyTypeItem),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/currency-types/update/${currencyTypeId}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function deleteCurrencyType(id) {
    const configOptions = {
        method: "DELETE",
        headers: {
        ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        "Content-Type": "application/json",
        },
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/currency-types/delete/${id}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}
